import { useTranslations } from "next-intl";
import * as m from "motion/react-m";
import { type RefObject, useEffect, useRef, useState } from "react";

export function AgentTextInput({
  voiceIsActive,
  enableInput,
  sessionIsActive,
  isPendingDisconnect,
  onSubmit,
  onActivate,
  textInputRef,
}: {
  voiceIsActive: boolean;
  /** When false, the input is inert and a click overlay triggers onActivate instead. */
  enableInput: boolean;
  sessionIsActive: boolean;
  isPendingDisconnect: boolean;
  onSubmit: (text: string) => void;
  onActivate: () => void;
  textInputRef: RefObject<HTMLInputElement | null>;
}) {
  const t = useTranslations("ClientKeys.ConvAI");
  const [messageText, setMessageText] = useState("");

  const prevSessionIsActiveRef = useRef(false);
  useEffect(() => {
    if (prevSessionIsActiveRef.current && !sessionIsActive) {
      setMessageText("");
    }
    prevSessionIsActiveRef.current = sessionIsActive;
  }, [sessionIsActive]);

  return (
    <m.form
      layout
      inert={voiceIsActive}
      className='tw-relative tw-ml-2.5 tw-w-0 tw-flex-auto tw-bg-white tw-overflow-hidden tw-shadow-[0_0_1px_rgba(0,0,0,0.4),0_4px_4px_rgba(0,0,0,0.04)] has-[input:focus,button:focus-visible]:tw-ring-1.5 has-[input:focus,button:focus-visible]:tw-ring-focus'
      style={{ borderRadius: 24 }}
      initial={false}
      animate={{ opacity: voiceIsActive ? 0 : 1 }}
      onSubmit={e => {
        e.preventDefault();
        const text = messageText.trim();
        if (text) {
          onSubmit(text);
          setMessageText("");
        }
      }}
    >
      {!enableInput && !sessionIsActive && (
        <button
          type='button'
          className='tw-absolute tw-inset-0 tw-outline-none tw-cursor-text tw-rounded-full'
          aria-label={t("or_type_message")}
          onClick={onActivate}
        />
      )}
      <m.input
        layout
        ref={textInputRef}
        type='text'
        value={messageText}
        onChange={e => setMessageText(e.target.value)}
        className='tw-block tw-w-56 tw-text-base tw-h-12 tw-px-4.5 tw-outline-none placeholder:tw-text-gray-400'
        aria-label={t("or_type_message")}
        placeholder={t("or_type_message")}
        inert={!enableInput || isPendingDisconnect}
      />
    </m.form>
  );
}
